import { store } from '../stores'
import { resetUserInfo, setUserInfo } from '../stores/userInfoSlice'
import {
  hydrateAuthFromSharedCookies,
  rejectAuthBootstrapIfLoggedOut,
  syncAuthCookiesFromStorage,
} from './crossDomainAuth'

function readAccessTokenFromStorage(): string | null {
  return (
    localStorage.getItem('access_token') || sessionStorage.getItem('access_token') || null
  )
}

function dispatchUserInfoFromStorage(): void {
  const at = readAccessTokenFromStorage()
  if (!at) return
  try {
    const ar = localStorage.getItem('user_account') || sessionStorage.getItem('user_account')
    const account = ar ? JSON.parse(ar) : undefined
    const sidRaw = localStorage.getItem('session_id') || sessionStorage.getItem('session_id')
    const n = sidRaw != null && sidRaw !== '' ? Number(sidRaw) : null
    const sessionId = n != null && !Number.isNaN(n) ? n : null
    store.dispatch(setUserInfo({ accessToken: at, account, sessionId }))
  } catch {
    store.dispatch(setUserInfo({ accessToken: at, account: undefined, sessionId: null }))
  }
}

/** app ↔ 랜딩 간 공유 쿠키와 Redux 헤더 상태를 맞춘다. (초기 로드·탭 복귀 시) */
export function reconcileLandingAuthState(): void {
  hydrateAuthFromSharedCookies()

  if (rejectAuthBootstrapIfLoggedOut()) {
    const { accessToken, sessionId } = store.getState().userInfo
    if (accessToken || sessionId) {
      store.dispatch(resetUserInfo())
    }
    return
  }

  syncAuthCookiesFromStorage()

  const at = readAccessTokenFromStorage()
  const { accessToken, sessionId } = store.getState().userInfo
  const wasLoggedIn = !!(accessToken || sessionId)

  if (!at) {
    if (wasLoggedIn) {
      store.dispatch(
        setUserInfo({ accessToken: null, account: undefined, sessionId: null })
      )
    }
    return
  }

  if (!wasLoggedIn || accessToken !== at) {
    dispatchUserInfoFromStorage()
  }
}
